module.exports = __webpack_public_path__ + "img/diamonds-3.0503285f.svg";